export default "__VITE_ASSET__CF9MiG7m__"